import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const loginThunk = createWrappedAsyncThunk(
  "auth/login",
  async (credentials) => {
    const {
      data: { user, token, refresh_token },
    } = await httpClient.publicPost(`sign-in`, credentials);

    httpClient.setAccessToken(token);
    httpClient.setRefreshToken(refresh_token);

    return user;
  },
);
